import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateBlog.css';

const CreateBlog = () => {
  const [newBlog, setNewBlog] = useState({
    title: '',
    description: '',
    category: '',
    content: '',
    image: null,
  });
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'image') {
      setNewBlog((prev) => ({ ...prev, image: files[0] }));
    } else {
      setNewBlog((prev) => ({ ...prev, [name]: value }));
    }
    console.log(newBlog);
  };

  const handleCreateBlog = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        title: newBlog.title,
        category: newBlog.category,
        content: newBlog.content,
        description: newBlog.description,
      })
    );
    formData.append('image', newBlog.image);

    try {
      const response = await fetch(
        'https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/add_blog.php',
        {
          method: 'POST',
          body: formData,
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log('Response:', data);

        

        setNewBlog({
          title: '',
          description: '',
          category: '',
          content: '',
          image: null,
        });

        alert('Blog created successfully!');
        navigate('/blog', { state: { fetchBlogs: true } });

      } else {
        console.error('Failed to create blog:', response.statusText);
        alert('Failed to create blog. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while creating the blog. Please try again.');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="create-blog-page">
      <h1>Create a New Blog</h1>
      <form onSubmit={handleCreateBlog} className="create-blog-form">
        <input
          type="text"
          name="title"
          placeholder="Blog Title"
          value={newBlog.title}
          onChange={handleInputChange}
          required
        />
        <textarea
          name="description"
          placeholder="Blog Description"
          value={newBlog.description}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="category"
          placeholder="Category"
          value={newBlog.category}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="content"
          placeholder="Content"
          value={newBlog.content}
          onChange={handleInputChange}
          required
        />
        <input
          type="file"
          name="image"
          onChange={handleInputChange}
          required
        />
        <button
          type="submit"
          className="create-blog-button"
          disabled={loading} // Disable button during loading
        >
          {loading ? 'Creating...' : 'Create Blog'} {/* Show loading text */}
        </button>
      </form>
    </div>
  );
};

export default CreateBlog;
